import logo from "../logo.png";
import showCase from "../chooseimg.jpg";
import instagram from "../instagramlogo.png";
import discoverImg from "../discoversecond.jpg";
import discoverfirst from "../discoverfirst.jpg";
import webImgfirst from "../webimgsecond.jpeg";
import webImgsecond from "../webimg.jpeg";
import webimgthird from "../webimgthird.jpeg";
import phone from "../phone.png";
import gmailImg from "../gmail.png";
import journeyimg from "../journeyimg.jpg";
import partnerback from "../partnerback.jpeg";
import partnerfront from "../partnerfront.jpeg";
import discoversecond from "../discoversecond.jpg";
import facebooklogo from "../facebooklogo.png";
import contact_facebook from "../contact_facebooklogo.png";
import contact_insta from "../contact_instagramlogo.png";
import servicefirstimg from "../servicefirstimg.jpeg";
import servicesecondimg from "../servicesecondimg.jpeg";
import servicethirdimg from "../servicethirdimg.jpeg";
import storyfirst from "../storyfirst.jpeg";
import storysecond from "../storysecond.jpeg";
import invitationwedding from "../invitationsweddingimg.jpg";
import invitationbirthday from "../invitationbirthdayimg.jpg";
import invitationchristening from "../invitationchristeningimg.jpg";
import invitationothers from "../invitationsothersimg.jpg";
import invitationengagement from "../invitationsengagementimg.jpg";
import errorImg from "../errorimg.png";
import oopsImg from "../oopsimg.png";
import robotimg from "../robotimg.png";
import iphone from "../iphone.png";
import laptop_phone from "../laptop-phone.png";
import callMeIcon from "../callMeIcon.png";
import closeCallModal from "../closeCallModal.png";
import sale_icon from "../sale-icon.png";

export const Imgs = {
  logo,
  showCase,
  instagram,
  discoverImg,
  discoverfirst,
  webImgsecond,
  webImgfirst,
  webimgthird,
  phone,
  gmailImg,
  journeyimg,
  partnerback,
  partnerfront,
  discoversecond,
  facebooklogo,
  servicefirstimg,
  servicesecondimg,
  servicethirdimg,
  storyfirst,
  storysecond,
  contact_facebook,
  contact_insta,
  invitationwedding,
  invitationbirthday,
  invitationchristening,
  invitationothers,
  invitationengagement,
  errorImg,
  oopsImg,
  robotimg,
  iphone,
  laptop_phone,
  callMeIcon,
  closeCallModal,
  sale_icon,
};
